import { Grid, Typography } from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import { I18nTranslator, translations } from "utils/i18n";

export const AppNoTableData = () => {
  return (
    <Grid
      container
      flex={1}
      height="100%"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <InboxIcon style={{ fontSize: 128 }} />
      <Typography fontSize="large" fontWeight="bold">
        {I18nTranslator(translations.table.noData)}
      </Typography>
    </Grid>
  );
};
